import TopManagerPage from './TopManagerPage.vue';

export const topManagerPage = {
    content: TopManagerPage,
    tickets: undefined,
};
